module.exports = __webpack_public_path__ + "img/ykhome1.3c8e3476.png";